<template>
  <CustomBlipLineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import CustomBlipLineChart from '@/components/cards/models/CustomBlipLineChart';
import { mapActions } from 'vuex';
import { setDateToUTC } from '@/utils/date';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BlipReportsTicketsInTime',
  components: {
    CustomBlipLineChart,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
    };
  },
  computed: {
    cardOptions() {
      return {
        chart: {
          type: 'spline',
        },
        legend: {
          enabled: true,
        },
        yAxis: {
          gridLineWidth: 0.5,
          tickLength: 0,
        },
      };
    },
    series() {
      const series = [
        {
          name: this.$t('components.BlipReportsTicketsInTime.label.series.openTickets'),
          data: [],
        },
        {
          name: this.$t('components.BlipReportsTicketsInTime.label.series.closedTickets'),
          data: [],
        },
      ];

      const dateIndexMap = {};

      this.rawSeries.forEach(response => {
        response.resource.items.forEach(item => {
          const dateMillis = setDateToUTC(item.date).getTime();
          const dataIndex = dateIndexMap[dateMillis];

          if (dataIndex === undefined) {
            dateIndexMap[dateMillis] = series[0].data.length;

            [item.open, item.closed].forEach((value, index) => {
              series[index].data.push({
                x: dateMillis,
                y: value,
              });
            });
          } else {
            [0, 1].forEach((index) => {
              series[index].data[dataIndex].y += [item.open, item.closed][index];
            });
          }
        });
      });

      for (const item of series) {
        item.data.sort((a, b) => a.x - b.x);
      }

      return series;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      this.getBlipService({
        servicePath: this.servicePath,
        itemId: this.itemId,
      })
        .then((responses) => {
          if (!options?.silentRefresh) {
            this.requestStatus = 'loading';
          }

          this.rawSeries = responses;

          this.requestStatus = 'success';
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>
